/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseReasoningSummaryTextDoneEvent = {
  type: "response.reasoning_summary_text.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  summaryIndex: number;
  text: string;
};

/** @internal */
export const ResponseReasoningSummaryTextDoneEvent$inboundSchema: z.ZodType<
  ResponseReasoningSummaryTextDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.reasoning_summary_text.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  summary_index: z.number().int(),
  text: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "summary_index": "summaryIndex",
  });
});
/** @internal */
export type ResponseReasoningSummaryTextDoneEvent$Outbound = {
  type: "response.reasoning_summary_text.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  summary_index: number;
  text: string;
};

/** @internal */
export const ResponseReasoningSummaryTextDoneEvent$outboundSchema: z.ZodType<
  ResponseReasoningSummaryTextDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseReasoningSummaryTextDoneEvent
> = z.object({
  type: z.literal("response.reasoning_summary_text.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  summaryIndex: z.number().int(),
  text: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    summaryIndex: "summary_index",
  });
});

export function responseReasoningSummaryTextDoneEventToJSON(
  responseReasoningSummaryTextDoneEvent: ResponseReasoningSummaryTextDoneEvent,
): string {
  return JSON.stringify(
    ResponseReasoningSummaryTextDoneEvent$outboundSchema.parse(
      responseReasoningSummaryTextDoneEvent,
    ),
  );
}
export function responseReasoningSummaryTextDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReasoningSummaryTextDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseReasoningSummaryTextDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReasoningSummaryTextDoneEvent' from JSON`,
  );
}
